var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"tip-text"},[_vm._v(" "+_vm._s(_vm.msgWrapper.msg.msgBody.content.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }